<div class="loading-center" *ngIf="loading">
	<div class="spinner-border text-warning" role="status">
		<span class="visually-hidden">Loading...</span>
	</div>
</div>
